let html = `
<svg><use xlink:href="#sprite-star"></use></svg>
`

export default html